module.exports = __webpack_public_path__ + "static/media/21_shape_l.6979bba4.webp";